import type { ContentItem } from '@sign/shared';

interface ContentViewProps {
  content: ContentItem[];
}

/** Renders the frozen field snapshot as a clean labeled card list. */
export default function ContentView({ content }: ContentViewProps) {
  if (content.length === 0) {
    return <p className="content-empty">暂无确认内容</p>;
  }
  return (
    <div className="content-list">
      {content.map((item, i) => {
        // 附件行改成上下布局：横向 flex 里图片会把右边的文字挤成一字宽的竖排，
        // 而且此时 value 就是文件名（现场照片-xx.jpg），图片已经在了，没必要再显示。
        const images = item.images ?? [];
        const hasImages = images.length > 0;
        return (
        <div
          className={hasImages ? 'content-row content-row--media' : 'content-row'}
          key={`${item.name}-${i}`}
        >
          <div className="content-row__name">{item.name}</div>
          {!hasImages && <div className="content-row__value">{item.value || '—'}</div>}
          {hasImages && (
            <div className="content-row__images">
              {images.map((src, j) => (
                <img
                  key={j}
                  src={src}
                  alt=""
                  className="content-row__img"
                  style={{ maxWidth: '100%', borderRadius: 8, marginTop: 8, display: 'block' }}
                />
              ))}
            </div>
          )}
        </div>
        );
      })}
    </div>
  );
}
